import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'

const ChevronDownIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='#5A5A5A'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
    <path d='M6 9l6 6l6 -6' />
  </svg>
)

const ChevronRightIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='#5A5A5A'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
    <path d='M9 6l6 6l-6 6' />
  </svg>
)

const ControlsTable = ({list}) => (
  <table className='table mt-3'>
    <thead>
      <tr className='py-4 border-bottom fw-bold' style={{color: '#5A5A5A'}}>
        <th className='min-w-350px'>Control Name</th>
        <th className='min-w-100px'>Framework</th>
      </tr>
    </thead>
    <tbody>
      {Array.isArray(list) &&
        list.map((item, index) => (
          <tr className='border-bottom my-2 fw-bold' style={{color: '#171717'}} key={item.control_id || index}>
            <td className='py-4'>{item.name}</td>
            <td className='py-4'>
              <div className='d-flex flex-wrap gap-1'>
                {Array.isArray(item.framework) && item.framework.length > 0 ? (
                  item.framework.map((framework, frameworkIndex) => (
                    <span key={frameworkIndex} className='badge border p-2 rounded-pill mb-1'>
                      <span className='text-center'>{framework}</span>
                    </span>
                  ))
                ) : (
                  <span className='badge border p-2 rounded-pill'>
                    <span className='text-center'>No Framework</span>
                  </span>
                )}
              </div>
            </td>
          </tr>
        ))}
    </tbody>
  </table>
)

const TestsTable = ({list}) => (
  <table className='table mt-3'>
    <thead>
      <tr className='py-4 border-bottom fw-bold' style={{color: '#5A5A5A'}}>
        <th className='min-w-350px'>Test Name</th>
        {/* <th className='min-w-100px'>Framework</th> */}
      </tr>
    </thead>
    <tbody>
      {Array.isArray(list) &&
        list.map((item, index) => (
          <tr className='border-bottom my-2 fw-bold' style={{color: '#171717'}} key={item.test_id || index}>
            <td className='py-4'>{item.name}</td>
            {/* <td className='py-4'>
              <span className='badge border p-2 rounded-pill mx-8'>
                <span className='text-center'>SOC 2 ‧ CC 6.1</span>
              </span>
            </td> */}
          </tr>
        ))}
    </tbody>
  </table>
)

interface TestsControlsModalProps {
  show: boolean
  onClose: () => void
  title: string
  controlsData?: any[]
  testsData?: any[]
  testsCount?: number
}

const TestsControlsModal: React.FC<TestsControlsModalProps> = ({
  show,
  onClose,
  title,
  controlsData = [],
  testsData = [],
  testsCount = 2,
}) => {
  const [modalOpenAccordion, setModalOpenAccordion] = useState(false)
  const [modalOpenAccordion2, setModalOpenAccordion2] = useState(false)

  // Reset accordion states when modal is closed
  useEffect(() => {
    if (!show) {
      setModalOpenAccordion(false)
      setModalOpenAccordion2(false)
    }
  }, [show])

  if (!show) return null

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton className="border-0 px-6 pb-0">
        <Modal.Title className="fw-semibold fs-2 text-gray-900">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{ 
          padding: '20px', 
          paddingTop: '15px', 
          paddingBottom: '20px',
          maxHeight: 'calc(100vh - 200px)',
          overflowY: 'auto'
        }}
      >
        <div className={`card mb-4 ${modalOpenAccordion ? 'px-6 pt-6' : 'p-6'}`}>
          <div
            className='d-flex'
            onClick={() => setModalOpenAccordion(!modalOpenAccordion)}
            style={{cursor: 'pointer'}}
          >
            <div className='row w-100'>
              <div className='col'>
                <div className='d-flex align-items-center'>
                  <span>{modalOpenAccordion ? <ChevronDownIcon /> : <ChevronRightIcon />}</span>
                  <span className='fs-6 fw-bold mx-4'>Controls</span>
                </div>
              </div>
              <div className='col-auto d-flex align-items-center ml-auto'>
                <div className='fw-semibold'>
                  {controlsData?.length || 2} Controls
                </div>
              </div>
            </div>
          </div>
          {modalOpenAccordion && <ControlsTable list={controlsData} />}
        </div>

        <div className={`card mb-4 ${modalOpenAccordion2 ? 'px-6 pt-6' : 'p-6'}`}>
          <div
            className='d-flex'
            onClick={() => setModalOpenAccordion2(!modalOpenAccordion2)}
            style={{cursor: 'pointer'}}
          >
            <div className='row w-100'>
              <div className='col'>
                <div className='d-flex align-items-center'>
                  <span>{modalOpenAccordion2 ? <ChevronDownIcon /> : <ChevronRightIcon />}</span>
                  <span className='fs-6 fw-bold mx-4'>Tests</span>
                </div>
              </div>
              <div className='col-auto d-flex align-items-center ml-auto'>
                <div className='fw-semibold'>{testsData?.length || testsCount} Tests</div>
              </div>
            </div>
          </div>
          {modalOpenAccordion2 && <TestsTable list={testsData} />}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default TestsControlsModal
